module.exports = __webpack_public_path__ + "img/icon6.7f7b64b3.png";